export default __webpack_public_path__ + "images/400c4b2029d1a575f660fe7611634cce.svg";